var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import client from "../../http/client";
import { extractApiErrorMessage } from "../../http/extractApiErrorMessage";
import "../ui.css";
import { RadixModal } from "../primitives/RadixModal";
import { RadixLoading } from "../primitives/RadixLoading";
import { CreditPaymentForm } from "./CreditPaymentForm";
import { avsCollectionSchema, billingZipCodeSchema } from "../avsCollection/avsCollectionSchema";
import { useCheckout } from "../../providers/CheckoutProvider";
import { useOrderIntent } from "../../providers/OrderIntentProvider";
import { bugsnagClient } from "../../themes/streamlined/streamlined";
import { createPaymentAttemptId } from "./paymentAttemptId";
import { getRecaptchaToken, withPaymentBotToken } from "./recaptcha";
var CreditPaymentContext = createContext(undefined);
var defaultBillingInfo = {
    billingAddress: "",
    billingZipcode: "",
};
var isDeliveryServiceType = function (serviceType) {
    if (!serviceType) {
        return false;
    }
    if (typeof serviceType.has_delivery !== "undefined" && serviceType.has_delivery !== null) {
        return Boolean(Number(serviceType.has_delivery));
    }
    return Number(serviceType.pos_id || 0) === 1;
};
var getCheckoutCommentFromCart = function (cart) {
    if (!cart) {
        return null;
    }
    var candidates = [cart.comment, cart.delivery_comment, cart.delivery_instructions, cart.instructions];
    for (var _i = 0, candidates_1 = candidates; _i < candidates_1.length; _i++) {
        var candidate = candidates_1[_i];
        if (typeof candidate === "string") {
            var trimmed = candidate.trim();
            if (trimmed.length > 0) {
                return trimmed;
            }
        }
    }
    return null;
};
export var CreditPaymentContextProvider = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var tip = _a.tip, handle_credit_order_complete = _a.handle_credit_order_complete, _k = _a.hidden, hidden = _k === void 0 ? false : _k, onExit = _a.onExit, children = _a.children, _l = _a.showPaymentForm, showPaymentForm = _l === void 0 ? true : _l, _m = _a.signUpRewards, signUpRewards = _m === void 0 ? false : _m, _o = _a.selectedPaymentType, selectedPaymentType = _o === void 0 ? "credit" : _o, _p = _a.checkoutComment, checkoutCommentFromProps = _p === void 0 ? null : _p;
    /*
    Avs configurations are the acceptable matching codes for that processor.
    If none are available billing details won't be collected.
     */
    var avsConfigs = (_b = window
        .session) === null || _b === void 0 ? void 0 : _b.avs_configs;
    var hasAvsConfigs = Boolean(avsConfigs && avsConfigs.length > 0);
    var _q = useState(null), cart = _q[0], setCart = _q[1];
    var _r = useState(null), processorInfo = _r[0], setProcessorInfo = _r[1];
    var _s = useState(defaultBillingInfo), billingInfo = _s[0], setBillingInfo = _s[1];
    var _t = useState([]), savedCards = _t[0], setSavedCards = _t[1];
    var _u = useState(null), selectedSavedCard = _u[0], setSelectedSavedCard = _u[1];
    var _v = useState(function () {
        return "avs";
    }), stage = _v[0], setStage = _v[1];
    var _w = useState(false), processorInfoFailed = _w[0], setProcessorInfoFailed = _w[1];
    /*
    By using a count instead of boolean we can stack loading calls
    and avoid toggles back and forth when multiple things are "loading".
     */
    var _x = useState(0), loadingCount = _x[0], setLoadingCount = _x[1];
    var _y = useState({
        open: false,
        title: "",
        message: "",
    }), errorModal = _y[0], setErrorModal = _y[1];
    var _z = useState(null), paymentError = _z[0], setPaymentError = _z[1];
    var _0 = useState(null), savedPaymentError = _0[0], setSavedPaymentError = _0[1];
    var _1 = useState(false), isSavedPaymentSubmitting = _1[0], setIsSavedPaymentSubmitting = _1[1];
    var _2 = useState(false), isPaymentSubmitting = _2[0], setIsPaymentSubmitting = _2[1];
    var _3 = useState(false), shouldStoreCard = _3[0], setShouldStoreCard = _3[1];
    var _4 = useCheckout(), isCurbsideOrder = _4.isCurbsideOrder, shouldSendSmsAlerts = _4.shouldSendSmsAlerts, hasMarketingOptIn = _4.hasMarketingOptIn, smsNumber = _4.smsNumber;
    var _5 = useOrderIntent(), currentAddress = _5.currentAddress, serviceType = _5.serviceType;
    var sessionGuest = (_c = window.session) === null || _c === void 0 ? void 0 : _c.is_guest;
    var isGuestUser = sessionGuest === true || sessionGuest === 1 || sessionGuest === "1";
    var isXplorPay = (processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.processor) === "xplorpay";
    var isAvsValid = isXplorPay
        ? billingZipCodeSchema.safeParse(billingInfo.billingZipcode).success
        : !hasAvsConfigs || avsCollectionSchema.safeParse({
            address: billingInfo.billingAddress,
            zipCode: billingInfo.billingZipcode,
        }).success;
    var requestHeaders = {
        "X-CSRF-TOKEN": (_d = window.session) === null || _d === void 0 ? void 0 : _d.token,
        credentials: "same-origin",
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
    };
    var checkoutUserId = (_g = (_e = cart === null || cart === void 0 ? void 0 : cart.user_id) !== null && _e !== void 0 ? _e : (_f = window.session) === null || _f === void 0 ? void 0 : _f.uid) !== null && _g !== void 0 ? _g : null;
    var orderIntentAddressId = (_h = currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.id) !== null && _h !== void 0 ? _h : null;
    var cartAddressId = (_j = cart === null || cart === void 0 ? void 0 : cart.address_id) !== null && _j !== void 0 ? _j : null;
    var checkoutAddressId = isDeliveryServiceType(serviceType)
        ? (orderIntentAddressId !== null && orderIntentAddressId !== void 0 ? orderIntentAddressId : cartAddressId)
        : cartAddressId;
    var checkoutComment = typeof checkoutCommentFromProps === "string" && checkoutCommentFromProps.trim().length > 0
        ? checkoutCommentFromProps.trim()
        : getCheckoutCommentFromCart(cart);
    var normalizedSmsNumber = typeof smsNumber === "string"
        ? smsNumber.trim() || null
        : null;
    var rewardsSignupPayload = signUpRewards ? { sign_up_rewards: true } : {};
    var setLoading = useCallback(function (isLoading) {
        setLoadingCount(function (count) {
            var next = isLoading ? count + 1 : Math.max(0, count - 1);
            return next;
        });
    }, []);
    var loading = loadingCount > 0;
    var handleError = useCallback(function (title, message) {
        setErrorModal({
            open: true,
            title: title,
            message: message,
        });
    }, []);
    var normalizePaymentError = useCallback(function (processor, error) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        var baseError = {
            code: "".concat(processor, "_unknown_error"),
            defaultMessage: "We could not process your payment. Please try again.",
            canRetry: true,
            details: error,
        };
        if (processor === "arrowpay") {
            if (axios.isAxiosError(error)) {
                var responseData = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
                return __assign(__assign({}, baseError), { code: (_b = responseData === null || responseData === void 0 ? void 0 : responseData.error_code) !== null && _b !== void 0 ? _b : "arrowpay_network_error", defaultMessage: extractApiErrorMessage(error, "We could not reach the payment processor. Please try again."), canRetry: true });
            }
            if (error && typeof error === "object" && "Message" in error) {
                return __assign(__assign({}, baseError), { code: "arrowpay_token_error", defaultMessage: String((_c = error.Message) !== null && _c !== void 0 ? _c : baseError.defaultMessage), canRetry: true });
            }
        }
        if (processor === "cayan") {
            if (axios.isAxiosError(error)) {
                return __assign(__assign({}, baseError), { code: "cayan_validation_error", defaultMessage: extractApiErrorMessage(error, "Cayan rejected the payment request."), canRetry: true });
            }
            if (error && typeof error === "object") {
                var errorRecord = error;
                var messageCandidate = (_d = errorRecord.message) !== null && _d !== void 0 ? _d : errorRecord.Message;
                if (typeof messageCandidate === "string" && messageCandidate.trim()) {
                    return __assign(__assign({}, baseError), { code: "cayan_validation_error", defaultMessage: messageCandidate, canRetry: true });
                }
            }
            if (error && typeof error === "object" && "status" in error) {
                return __assign(__assign({}, baseError), { code: "cayan_processor_error", defaultMessage: "Cayan rejected the payment request.", canRetry: true });
            }
        }
        if (processor === "vantiv") {
            if (axios.isAxiosError(error)) {
                var responseData = (_e = error.response) === null || _e === void 0 ? void 0 : _e.data;
                return __assign(__assign({}, baseError), { code: String((_f = responseData === null || responseData === void 0 ? void 0 : responseData.errorCode) !== null && _f !== void 0 ? _f : "vantiv_error"), defaultMessage: extractApiErrorMessage(error, "Vantiv could not authorize this payment."), canRetry: true });
            }
            if (error && typeof error === "object" && ("errorCode" in error || "message" in error)) {
                return __assign(__assign({}, baseError), { code: String((_g = error.errorCode) !== null && _g !== void 0 ? _g : "vantiv_error"), defaultMessage: String((_h = error.message) !== null && _h !== void 0 ? _h : "Vantiv could not authorize this payment."), canRetry: true });
            }
        }
        if (processor === "shift4") {
            if (axios.isAxiosError(error)) {
                var responseData = (_j = error.response) === null || _j === void 0 ? void 0 : _j.data;
                return __assign(__assign({}, baseError), { code: String((_k = responseData === null || responseData === void 0 ? void 0 : responseData.code) !== null && _k !== void 0 ? _k : "shift4_error"), defaultMessage: extractApiErrorMessage(error, "Shift4 reported an issue with the payment."), canRetry: true });
            }
            if (error && typeof error === "object" && ("code" in error || "message" in error)) {
                return __assign(__assign({}, baseError), { code: String((_l = error.code) !== null && _l !== void 0 ? _l : "shift4_error"), defaultMessage: String((_m = error.message) !== null && _m !== void 0 ? _m : "Shift4 reported an issue with the payment."), canRetry: true });
            }
        }
        if (processor === "xplorpay") {
            if (axios.isAxiosError(error)) {
                var responseData = (_o = error.response) === null || _o === void 0 ? void 0 : _o.data;
                return __assign(__assign({}, baseError), { code: String((_p = responseData === null || responseData === void 0 ? void 0 : responseData.code) !== null && _p !== void 0 ? _p : "xplorpay_error"), defaultMessage: extractApiErrorMessage(error, "The payment processor reported an issue with the payment."), canRetry: true });
            }
            if (error && typeof error === "object" && ("code" in error || "message" in error)) {
                return __assign(__assign({}, baseError), { code: String((_q = error.code) !== null && _q !== void 0 ? _q : "xplorpay_error"), defaultMessage: String((_r = error.message) !== null && _r !== void 0 ? _r : "The payment processor reported an issue with the payment."), canRetry: true });
            }
        }
        return baseError;
    }, []);
    var reportProcessorError = useCallback(function (processor, error) {
        setPaymentError(normalizePaymentError(processor, error));
    }, [normalizePaymentError]);
    var clearPaymentError = useCallback(function () {
        setPaymentError(null);
    }, []);
    var clearSavedPaymentError = useCallback(function () {
        setSavedPaymentError(null);
    }, []);
    var markPaymentSubmitting = useCallback(function (submitting) {
        setIsPaymentSubmitting(submitting);
    }, []);
    var payWithSavedCard = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var processor, shouldReleaseSubmitting, recaptchaToken, _a, response, _b, orderPayload, order, error_1;
        var _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!(selectedSavedCard === null || selectedSavedCard === void 0 ? void 0 : selectedSavedCard.cc_token)) {
                        setSavedPaymentError(normalizePaymentError("arrowpay", { Message: "We could not process your payment. Please try again or use a different payment method" }));
                        return [2 /*return*/];
                    }
                    processor = typeof (processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.processor) === "string" ? processorInfo.processor : "";
                    if (processor !== "arrowpay" && processor !== "shift4" && processor !== "xplorpay") {
                        setSavedPaymentError(normalizePaymentError("arrowpay", { Message: "Saved cards are not available for this payment processor." }));
                        return [2 /*return*/];
                    }
                    if (processor === "xplorpay" && !isAvsValid) {
                        setSavedPaymentError(normalizePaymentError("xplorpay", {
                            message: "A valid billing ZIP code is required.",
                        }));
                        return [2 /*return*/];
                    }
                    setIsSavedPaymentSubmitting(true);
                    markPaymentSubmitting(true);
                    clearSavedPaymentError();
                    shouldReleaseSubmitting = true;
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 10, 11, 12]);
                    if (!(processor === "arrowpay")) return [3 /*break*/, 3];
                    return [4 /*yield*/, getRecaptchaToken(processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.recaptcha)];
                case 2:
                    _a = _e.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, withPaymentBotToken({})];
                case 4:
                    _a = (_e.sent()).recaptcha_token;
                    _e.label = 5;
                case 5:
                    recaptchaToken = _a;
                    if (!(processor === "shift4")) return [3 /*break*/, 7];
                    return [4 /*yield*/, client.post("/order/shift4", __assign(__assign({ recaptcha_token: recaptchaToken, i4go_uniqueid: selectedSavedCard.cc_token, using_stored_token: true, cart_id: cart === null || cart === void 0 ? void 0 : cart.id, card_friendly_name: null, should_store_card: false, address_id: checkoutAddressId, user_id: checkoutUserId, comment: checkoutComment, using_on_file: true, is_curbside_order: isCurbsideOrder, should_send_sms_alerts: shouldSendSmsAlerts, sms_number: normalizedSmsNumber, has_marketing_opt_in: hasMarketingOptIn }, rewardsSignupPayload), { headers: requestHeaders }))];
                case 6:
                    _b = _e.sent();
                    return [3 /*break*/, 9];
                case 7: return [4 /*yield*/, client.post(processor === "xplorpay" ? "/order/xplorpay" : "/order/arrowpay", __assign({ payment_attempt_id: createPaymentAttemptId(), recaptcha_token: recaptchaToken, token: selectedSavedCard.cc_token, address: billingInfo.billingAddress, zip: billingInfo.billingZipcode, comment: checkoutComment, using_on_file: true, address_id: checkoutAddressId, user_id: checkoutUserId, is_curbside_order: isCurbsideOrder, should_send_sms_alerts: shouldSendSmsAlerts, sms_number: normalizedSmsNumber, has_marketing_opt_in: hasMarketingOptIn }, rewardsSignupPayload))];
                case 8:
                    _b = _e.sent();
                    _e.label = 9;
                case 9:
                    response = _b;
                    if (response.status === 200) {
                        shouldReleaseSubmitting = false;
                        orderPayload = (_c = response.data) === null || _c === void 0 ? void 0 : _c.order_data;
                        order = typeof orderPayload === "string" ? JSON.parse(orderPayload) : (_d = response.data) === null || _d === void 0 ? void 0 : _d.order;
                        handle_credit_order_complete(order);
                    }
                    return [3 /*break*/, 12];
                case 10:
                    error_1 = _e.sent();
                    setSavedPaymentError(normalizePaymentError(processor === "shift4" || processor === "xplorpay" ? processor : "arrowpay", error_1));
                    return [3 /*break*/, 12];
                case 11:
                    setIsSavedPaymentSubmitting(false);
                    if (shouldReleaseSubmitting) {
                        markPaymentSubmitting(false);
                    }
                    return [7 /*endfinally*/];
                case 12: return [2 /*return*/];
            }
        });
    }); }, [
        cart === null || cart === void 0 ? void 0 : cart.id,
        checkoutComment,
        checkoutUserId,
        billingInfo.billingAddress,
        billingInfo.billingZipcode,
        clearSavedPaymentError,
        handle_credit_order_complete,
        isCurbsideOrder,
        isAvsValid,
        markPaymentSubmitting,
        normalizedSmsNumber,
        requestHeaders,
        rewardsSignupPayload,
        processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.processor,
        processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.recaptcha,
        normalizePaymentError,
        selectedSavedCard,
        checkoutAddressId,
        shouldSendSmsAlerts,
    ]);
    var resetPaymentFlow = useCallback(function () {
        setSelectedSavedCard(null);
        setSavedCards([]);
        setProcessorInfo(null);
        setProcessorInfoFailed(false);
        setPaymentError(null);
        setSavedPaymentError(null);
        setIsSavedPaymentSubmitting(false);
        setIsPaymentSubmitting(false);
        setShouldStoreCard(false);
        setBillingInfo(defaultBillingInfo);
        setStage("avs");
    }, []);
    var refreshCart = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (hidden) {
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, client.get("/cart/api").catch(function (error) {
                            bugsnagClient.notify(error, function (event) {
                                var _a, _b, _c, _d, _e, _f;
                                var method = (_b = (_a = error.config) === null || _a === void 0 ? void 0 : _a.method) === null || _b === void 0 ? void 0 : _b.toUpperCase();
                                var url = (_c = error.config) === null || _c === void 0 ? void 0 : _c.url;
                                var reason = 'unknown';
                                if (error.code === 'ECONNABORTED') {
                                    reason = 'timeout';
                                }
                                else if ((_d = error.response) === null || _d === void 0 ? void 0 : _d.status) {
                                    reason = error.response.status;
                                }
                                event.groupingHash = "".concat(method, ":").concat(url, ":").concat(reason);
                                event.addMetadata('axios', {
                                    method: method,
                                    url: url,
                                    status: (_e = error.response) === null || _e === void 0 ? void 0 : _e.status,
                                    timeout: (_f = error.config) === null || _f === void 0 ? void 0 : _f.timeout,
                                    error: error
                                });
                            });
                        })];
                case 2:
                    response = _c.sent();
                    setCart((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.cart) !== null && _b !== void 0 ? _b : null);
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _c.sent();
                    setCart(null);
                    handleError("Unable to load cart", "Please refresh and try again.");
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [handleError, hidden, setLoading]);
    var applyProcessorInfoResponse = useCallback(function (responseData) {
        var _a;
        setProcessorInfo(responseData);
        var responseSavedCards = isGuestUser ? [] : ((_a = responseData === null || responseData === void 0 ? void 0 : responseData.saved_cards) !== null && _a !== void 0 ? _a : []);
        setSavedCards(responseSavedCards);
        if (responseSavedCards.length > 0 && !selectedSavedCard) {
            setStage("savedCard");
        }
        else if (responseSavedCards.length === 0 && stage === "savedCard") {
            setStage("payment");
        }
    }, [isGuestUser, selectedSavedCard, setStage, stage]);
    var handleProcessorInfoRefreshError = useCallback(function (error) {
        var _a;
        setProcessorInfo(null);
        if (axios.isAxiosError(error) && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) && error.response.status >= 400) {
            setProcessorInfoFailed(true);
        }
        var errorMessage = extractApiErrorMessage(error, "We could not load payment details.");
        handleError("Payment processor error", errorMessage);
    }, [handleError]);
    var refreshProcessorInfo = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (hidden) {
                        return [2 /*return*/];
                    }
                    setProcessorInfoFailed(false);
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, withPaymentBotToken({
                            tip_amount: Number(tip) || 0,
                            billingAddress: billingInfo.billingAddress,
                            zip: billingInfo.billingZipcode,
                        }, true).then(function (paymentData) { return client.post("/store/credit_processor/api", paymentData); })];
                case 2:
                    response = _b.sent();
                    applyProcessorInfoResponse((_a = response.data) !== null && _a !== void 0 ? _a : null);
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _b.sent();
                    handleProcessorInfoRefreshError(error_3);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        applyProcessorInfoResponse,
        billingInfo.billingAddress,
        billingInfo.billingZipcode,
        handleProcessorInfoRefreshError,
        hidden,
        setLoading,
        tip,
    ]);
    var refreshVantivProcessorInfo = useCallback(function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (options) {
            var requestTipAmount, requestPayload, response, error_4;
            var _a;
            if (options === void 0) { options = {}; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (hidden) {
                            return [2 /*return*/];
                        }
                        setProcessorInfoFailed(false);
                        setLoading(true);
                        requestTipAmount = typeof options.tipAmount === "undefined"
                            ? tip
                            : options.tipAmount;
                        requestPayload = {
                            tip_amount: Number(requestTipAmount) || 0,
                            billingAddress: billingInfo.billingAddress,
                            zip: billingInfo.billingZipcode,
                        };
                        if (options.forceNewPayment) {
                            requestPayload.force_new_vantiv_payment = true;
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, withPaymentBotToken(requestPayload, true).then(function (paymentData) { return client.post("/store/credit_processor/api", paymentData); })];
                    case 2:
                        response = _b.sent();
                        applyProcessorInfoResponse((_a = response.data) !== null && _a !== void 0 ? _a : null);
                        return [3 /*break*/, 5];
                    case 3:
                        error_4 = _b.sent();
                        handleProcessorInfoRefreshError(error_4);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [
        applyProcessorInfoResponse,
        billingInfo.billingAddress,
        billingInfo.billingZipcode,
        handleProcessorInfoRefreshError,
        hidden,
        setLoading,
        tip,
    ]);
    //The callback for AVSCollection to update billing details.
    var updateBillingInfo = useCallback(function (next) {
        setBillingInfo(function (current) { return (typeof next === "function" ? next(current) : next); });
    }, []);
    useEffect(function () {
        if (!hidden) {
            refreshCart();
        }
    }, [hidden, refreshCart]);
    useEffect(function () {
        if (hidden) {
            return;
        }
        if (stage !== "avs") {
            return;
        }
        var isShift4Processor = (processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.processor) === "shift4";
        if (!hasAvsConfigs || isShift4Processor) {
            setStage(savedCards.length > 0 ? "savedCard" : "payment");
        }
    }, [hasAvsConfigs, hidden, processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.processor, savedCards.length, stage]);
    useEffect(function () {
        if (hidden) {
            return;
        }
        if (!processorInfo && !loading && !processorInfoFailed) {
            refreshProcessorInfo();
        }
    }, [hidden, loading, processorInfo, processorInfoFailed, refreshProcessorInfo, stage]);
    var value = useMemo(function () { return ({
        cart: cart,
        processorInfo: processorInfo,
        loading: loading,
        requestHeaders: requestHeaders,
        tip: tip,
        billingInfo: billingInfo,
        setBillingInfo: updateBillingInfo,
        stage: stage,
        setStage: setStage,
        hasAvsConfigs: hasAvsConfigs,
        savedCards: savedCards,
        selectedSavedCard: selectedSavedCard,
        setSelectedSavedCard: setSelectedSavedCard,
        handleCreditOrderComplete: handle_credit_order_complete,
        refreshCart: refreshCart,
        refreshProcessorInfo: refreshProcessorInfo,
        refreshVantivProcessorInfo: refreshVantivProcessorInfo,
        paymentError: paymentError,
        reportProcessorError: reportProcessorError,
        clearPaymentError: clearPaymentError,
        savedPaymentError: savedPaymentError,
        clearSavedPaymentError: clearSavedPaymentError,
        isSavedPaymentSubmitting: isSavedPaymentSubmitting,
        isPaymentSubmitting: isPaymentSubmitting,
        markPaymentSubmitting: markPaymentSubmitting,
        payWithSavedCard: payWithSavedCard,
        resetPaymentFlow: resetPaymentFlow,
        onExit: onExit,
        isGuestUser: isGuestUser,
        isAvsValid: isAvsValid,
        checkoutUserId: checkoutUserId,
        checkoutAddressId: checkoutAddressId,
        checkoutComment: checkoutComment,
        isCurbsideOrder: isCurbsideOrder,
        shouldSendSmsAlerts: shouldSendSmsAlerts,
        hasMarketingOptIn: hasMarketingOptIn,
        smsNumber: normalizedSmsNumber,
        shouldStoreCard: shouldStoreCard,
        setShouldStoreCard: setShouldStoreCard,
        signUpRewards: signUpRewards,
        selectedPaymentType: selectedPaymentType,
    }); }, [
        billingInfo,
        cart,
        checkoutAddressId,
        checkoutComment,
        checkoutUserId,
        isCurbsideOrder,
        hasMarketingOptIn,
        handle_credit_order_complete,
        hasAvsConfigs,
        loading,
        onExit,
        isGuestUser,
        isAvsValid,
        paymentError,
        savedPaymentError,
        processorInfo,
        requestHeaders,
        refreshCart,
        refreshProcessorInfo,
        refreshVantivProcessorInfo,
        reportProcessorError,
        clearPaymentError,
        clearSavedPaymentError,
        isSavedPaymentSubmitting,
        isPaymentSubmitting,
        markPaymentSubmitting,
        payWithSavedCard,
        resetPaymentFlow,
        savedCards,
        selectedSavedCard,
        shouldSendSmsAlerts,
        hasMarketingOptIn,
        normalizedSmsNumber,
        shouldStoreCard,
        signUpRewards,
        selectedPaymentType,
        setStage,
        stage,
        tip,
        updateBillingInfo,
    ]);
    return (React.createElement(CreditPaymentContext.Provider, { value: value },
        hidden ? null : (React.createElement(React.Fragment, null,
            React.createElement(RadixModal, { open: errorModal.open, onOpenChange: function (open) { return setErrorModal(function (prev) { return (__assign(__assign({}, prev), { open: open })); }); }, title: errorModal.title, description: errorModal.message, status: "error" }),
            loading ? React.createElement(RadixLoading, { label: "Loading payment details" }) : null)),
        children,
        showPaymentForm ? React.createElement(CreditPaymentForm, null) : null));
};
export var useCreditPaymentContext = function () {
    var context = useContext(CreditPaymentContext);
    if (!context) {
        throw new Error("useCreditPaymentContext must be used within CreditPaymentContextProvider");
    }
    return context;
};
